import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c6addc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_c_title nav_aside" }
const _hoisted_2 = { class: "return_bin" }
const _hoisted_3 = { class: "mod_c_tbody select_none" }
const _hoisted_4 = { class: "container_textLeft" }
const _hoisted_5 = { class: "establish_table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "还原", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "删除", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mod_pagin establish_pagation" }

import { LeftOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { reactive, ref, computed, unref } from 'vue';
import moment from 'moment';
import { DatePicker, Input, Table, Popover, Pagination, message } from 'ant-design-vue';
import http from '@/api/conentCenter/communal';
import CDelModal from '@/components/CDelModal.vue';
import CReductionModal from '@/components/CReductionModal.vue';
import CReductionAll from '@/components/CReductionAll.vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
type Key = ColumnProps['key'];

interface DataType {
  key: number;
  name: string;
  created_at: string;
  show: number;
}
// 分页

export default /*#__PURE__*/_defineComponent({
  __name: 'recycleBin',
  emits: ['createStatus'],
  setup(__props, { emit }) {


const showLoading = ref<boolean>(false);
const modalVisible = ref(false);
const modalRecycle = ref(false);
const modalReduction = ref(false);
const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};
const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aInputSearch = Input.Search;
const aTable = Table;
const aPopover = Popover;
const aPagination = Pagination;

const goBack = () => {
  emit('createStatus', true);
};
const operation = reactive({
  use_time_filter: ref([]), // 使用记录时间筛选
  inputSearch: '',
});
//表格头
const columns = [
  {
    title: '门户名称',
    dataIndex: 'name',
    width: '35%',
    align: 'left',
  },
  {
    title: '显示开关',
    dataIndex: 'show',
    width: '20%',
    slots: {
      customRender: 'show',
    },
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: '20%',
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'portalHandle',
    width: '35%',
    align: 'center',
    slots: {
      customRender: 'portalHandle',
    },
  },
];
//表格数据
const datafol = ref<DataType[]>([]);
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 0, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
// 门户回收站列表
const recycleBin = () => {
  showLoading.value = true;
  let recycle = {
    keyword: operation.inputSearch,
    start_at: operation.use_time_filter[0] ? new Date(operation.use_time_filter[0]) : operation.use_time_filter[0],
    end_at: operation.use_time_filter[1] ? new Date(operation.use_time_filter[1]) : operation.use_time_filter[1],
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  http
    .getRecycleBin({ params: recycle })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      const degree = res.data.data.data;
      datafol.value = degree;
      if (res.data.code == 200) {
        showLoading.value = false;
      }
    })
    .catch((res) => {
      showLoading.value = false;
      message.destroy();
      message.error(res.data.error);
    });
};
recycleBin();

//表格删除按钮
const portalId = ref();
const tabDel = (record: any) => {
  selectedRowKeys.value = [];
  selectedRowKeys.value.push(record.portal_id);
  modalVisible.value = true;
  portalId.value = record.portal_id; //获取列表portal_id
};
// 还原门户
const ReductionPortal = (item: any) => {
  modalRecycle.value = true;
  portalId.value = item.portal_id;
  selectedRowKeys.value.push(item.id);
};
// 还原取消按钮
const openRecycle = () => {
  modalRecycle.value = false;
  selectedRowKeys.value = [];
};
const removeRecycle = () => {
  modalRecycle.value = false;
  showLoading.value = true;
  let reduction = {
    portal_id: portalId.value,
  };
  http
    .getReductionPortal({ params: reduction })
    .then((res) => {
      if (res.data.code == 200) {
        recycleBin();
        showLoading.value = false;
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      showLoading.value = false;
      message.destroy();
      message.error(res.data.error);
    });
};
//弹框删除按钮
const openDelModat = () => {
  modalVisible.value = false;
  selectedRowKeys.value = [];
};
////弹框确认按钮
const removeLiveData = () => {
  modalVisible.value = false;
  let del = {
    portal_id: portalId.value,
  };
  http.getRemoveCompletely({ params: del }).then((res) => {
    recycleBin();
    message.success('删除成功!');
  });
};
const selectedRowKeys = ref<Key[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
// 全部恢复
const RestoreAll = () => {
  modalReduction.value = true;
  let data: any = [];
  datafol.value.map((res: any) => {
    data.push(res.portal_id);
  });
  portalAll.value = data;
};
// 取消全部恢复
const openDelReduction = () => {
  modalReduction.value = false;
  selectedRowKeys.value = [];
};
// 确认全部恢复
const portalAll = ref();
const removeReduction = (index: number) => {
  console.log(index, 'yyyy');
  modalReduction.value = false;
  let reductionAll = {
    portal_id: selectedRowKeys.value.join(','),
  };
  http
    .getReductionPortal({ params: reductionAll })
    .then((res) => {
      if (res.data.code == 200) {
        selectedRowKeys.value = [];
        recycleBin();
        showLoading.value = false;
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      showLoading.value = false;
      message.destroy();
      message.error(res.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" 回收站 "),
      _createElementVNode("div", {
        class: "title_right",
        onClick: goBack
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(LeftOutlined)),
          _createTextVNode("返回")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(aRangePicker), {
          value: operation.use_time_filter,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((operation.use_time_filter) = $event)),
          ranges: ranges,
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          class: "mod_range_picker container_textLeft_picker",
          onChange: recycleBin
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search",
          value: operation.inputSearch,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((operation.inputSearch) = $event)),
          onSearch: recycleBin,
          placeholder: "请输入门户名称"
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_a_button, {
        class: "all_refresh",
        onClick: RestoreAll
      }, {
        default: _withCtx(() => [
          _createTextVNode("全部恢复")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(aTable), {
        loading: showLoading.value,
        columns: columns,
        "data-source": datafol.value,
        "row-selection": _unref(rowSelection),
        pagination: false,
        class: "liveList_w",
        rowKey: 
          (res) => {
            return res.portal_id;
          }
        
      }, {
        show: _withCtx(({ record }) => [
          _createVNode(_component_a_switch, {
            checked: record.show,
            "onUpdate:checked": ($event: any) => ((record.show) = $event),
            "checked-value": 1,
            "un-checked-value": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(record.text), 1)
            ]),
            _: 2
          }, 1032, ["checked", "onUpdate:checked"])
        ]),
        portalHandle: _withCtx(({ record }) => [
          _createVNode(_unref(aPopover), {
            placement: "left",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                centered: "",
                onClick: ($event: any) => (ReductionPortal(record))
              }, [
                _createVNode(_component_svg_icon, {
                  class: "liveList_outs",
                  "icon-class": "reduction"
                }),
                _createTextVNode(" " + _toDisplayString(record.text), 1)
              ], 8, _hoisted_7)
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aPopover), {
            placement: "left",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                centered: "",
                onClick: ($event: any) => (tabDel(record))
              }, [
                _createVNode(_component_svg_icon, { "icon-class": "unionDel" }),
                _createTextVNode(" " + _toDisplayString(record.text), 1)
              ], 8, _hoisted_9)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["loading", "data-source", "row-selection", "rowKey"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (datafol.value.length !== 0)
        ? (_openBlock(), _createBlock(_unref(aPagination), {
            key: 0,
            "show-quick-jumper": "",
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-size-changer": "",
            onChange: recycleBin,
            onShowSizeChange: recycleBin
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CDelModal, {
      visible: modalVisible.value,
      centered: "",
      close: openDelModat,
      ok: removeLiveData
    }, null, 8, ["visible"]),
    _createVNode(CReductionModal, {
      visible: modalRecycle.value,
      centered: "",
      close: openRecycle,
      ok: removeRecycle
    }, null, 8, ["visible"]),
    _createVNode(CReductionAll, {
      visible: modalReduction.value,
      centered: "",
      close: openDelReduction,
      ok: removeReduction
    }, null, 8, ["visible"])
  ], 64))
}
}

})